import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { useApp, scrollToSection } from "../store";

export const Footer = () => {
  const { c, t } = useApp();
  const year = new Date().getFullYear();

  return (
    <footer data-testid="site-footer" className="text-white border-t border-[var(--accent-soft)]/10" style={{ background: "var(--sec-footer-bg, #101E3D)" }}>
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid sm:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3">
            {c("logo_image") ? (
              <img
                src={c("logo_image")}
                alt="Polynésie Gestion et Projet"
                data-testid="footer-logo-image"
                className="h-12 w-auto max-w-[240px] object-contain rounded-sm"
              />
            ) : (
              <>
                <span className="w-10 h-10 grid place-items-center bg-[var(--accent)] text-[#0B132B] font-display font-bold text-xl">G</span>
                <span className="leading-tight">
                  <span className="block font-display font-semibold tracking-wide text-sm">POLYNÉSIE GESTION</span>
                  <span className="block font-mono2 text-[10px] uppercase tracking-[0.35em] text-[var(--accent)]">et Projet</span>
                </span>
              </>
            )}
          </div>
          <p className="mt-4 text-sm text-white/55">{t("footer_tagline")}</p>
        </div>

        <div>
          <h4 className="font-mono2 text-[11px] uppercase tracking-[0.3em] text-white/50 mb-4">{t("footer_nav")}</h4>
          <div className="flex flex-col gap-2.5">
            {[
              ["nav_about", "#cabinet"],
              ["nav_services", "#expertises"],
              ["nav_method", "#methode"],
              ["nav_contact", "#contact"],
            ].map(([key, sel]) => (              <button
                key={key}
                data-testid={`footer-${key.replace("nav_", "")}-link`}
                onClick={() => scrollToSection(sel)}
                className="text-left text-sm text-white/65 hover:text-[var(--accent-soft)] transition-colors duration-300"
              >
                {t(key)}
              </button>
            ))}
            <Link
              data-testid="footer-news-link"
              to="/actualites"
              className="text-left text-sm text-white/65 hover:text-[var(--accent-soft)] transition-colors duration-300"
            >
              {t("nav_news")}
            </Link>
          </div>
        </div>

        <div>
          <h4 className="font-mono2 text-[11px] uppercase tracking-[0.3em] text-white/50 mb-4">{t("footer_contact")}</h4>
          <div className="flex flex-col gap-2.5 text-sm text-white/65">
            <span className="break-all">{c("contact_email")}</span>
            <span>{c("contact_phone")}</span>
            <span>{c("contact_address")}</span>
          </div>
        </div>
      </div>

      <div className="border-t border-[var(--accent-soft)]/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-wrap items-center justify-between gap-4">
          <p className="font-mono2 text-[11px] uppercase tracking-[0.2em] text-white/45">
            © {year} Polynésie Gestion et Projet — {t("footer_rights")}
          </p>
          <div className="flex items-center gap-5">
            <Link
              data-testid="footer-legal-link"
              to="/mentions-legales"
              className="font-mono2 text-[11px] uppercase tracking-[0.2em] text-white/45 hover:text-[var(--accent-soft)] transition-colors duration-300"
            >
              {t("footer_legal")}
            </Link>
            <Link
              data-testid="footer-admin-link"
              to="/admin"
              className="inline-flex items-center gap-2 font-mono2 text-[11px] uppercase tracking-[0.2em] text-white/45 hover:text-[var(--accent-soft)] transition-colors duration-300"
            >
              <Lock size={12} />
              {t("footer_admin")}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
